module.exports = __webpack_public_path__ + "img/showmorw03.81dc9b8.png";